import React from 'react';
import brandMark from '../../assets/GrabTime_Clean_Trimmed.png';
import './OnboardingShell.css';

const buildClassName = (...classNames) => classNames.filter(Boolean).join(' ');

const renderMemberPortraitProgress = ({ progressMetaStart, progressMetaEnd, progressPercent }) => (
  <div className="welcome-onboarding__progress-wrap">
    <div className="welcome-onboarding__progress">
        <div
          className="welcome-onboarding__progress-meta"
          title={`${progressMetaStart} — ${progressMetaEnd}`}
        >
        <span className="welcome-onboarding__progress-meta-start">{progressMetaStart}</span>
        <span className="welcome-onboarding__progress-meta-end">{progressMetaEnd}</span>
      </div>
      <div className="welcome-onboarding__progress-track">
        <div
          className="welcome-onboarding__progress-fill"
          style={{ width: `${Math.max(0, Math.min(progressPercent, 100))}%` }}
        />
      </div>
    </div>
  </div>
);

const renderSetupProgress = ({ setupSteps, setupCurrentStep }) => {
  const totalSteps = setupSteps.length || 1;
  const safeCurrentStep = Math.max(1, Math.min(setupCurrentStep, totalSteps));
  const percent = Math.round((safeCurrentStep / totalSteps) * 100);

  return (
    <div className="welcome-onboarding__progress-wrap">
      <div className="welcome-onboarding__progress welcome-onboarding__progress--setup">
        <div
          className="welcome-onboarding__progress-meta"
          title={`Step ${safeCurrentStep} of ${totalSteps} — Setup`}
        >
          <span className="welcome-onboarding__progress-meta-start">{`Step ${safeCurrentStep} of ${totalSteps}`}</span>
          <span className="welcome-onboarding__progress-meta-end">Setup</span>
        </div>
        <div className="welcome-onboarding__setup-steps" aria-label="Setup progress">
          {setupSteps.map((label, index) => {
            const stepNumber = index + 1;
            const stateClassName = stepNumber < safeCurrentStep
              ? 'welcome-onboarding__setup-step--complete'
              : stepNumber === safeCurrentStep
                ? 'welcome-onboarding__setup-step--active'
                : '';

            return (
              <div
                key={label}
                className={buildClassName('welcome-onboarding__setup-step', stateClassName)}
              >
                <span className="welcome-onboarding__setup-step-index">{stepNumber}</span>
                <span>{label}</span>
              </div>
            );
          })}
        </div>
        <div className="welcome-onboarding__progress-track">
          <div
            className="welcome-onboarding__progress-fill"
            style={{ width: `${percent}%` }}
          />
        </div>
      </div>
    </div>
  );
};

const OnboardingShell = ({
  children,
  footer = null,
  onClose = null,
  closeLabel = 'Close onboarding',
  brandLabel = 'GrabTime Welcome',
  immersive = false,
  centerStage = false,
  stageVariant = null,
  rootClassName = '',
  shellClassName = '',
  stageClassName = '',
  panelClassName = '',
  progressMode = 'none',
  progressMetaStart = '',
  progressMetaEnd = '',
  progressPercent = 0,
  setupSteps = [],
  setupCurrentStep = 1,
}) => {
  const rootClasses = buildClassName(
    'welcome-onboarding',
    immersive && 'welcome-onboarding--immersive',
    rootClassName,
  );
  const shellClasses = buildClassName('welcome-onboarding__shell', shellClassName);
  const stageClasses = buildClassName(
    'welcome-onboarding__stage',
    centerStage && 'welcome-onboarding__stage--mobile-centered',
    stageVariant === 'auth' && 'welcome-onboarding__stage--auth',
    stageClassName,
  );
  const panelClasses = buildClassName(
    'welcome-onboarding__panel',
    stageVariant === 'auth' && 'welcome-onboarding__panel--auth',
    panelClassName,
  );

  return (
    <div className={rootClasses}>
      <div className={shellClasses}>
        <div className="welcome-onboarding__topbar">
          <div className="welcome-onboarding__brand">
            <img src={brandMark} alt="" aria-hidden="true" className="welcome-onboarding__brand-mark" />
            <span className="welcome-onboarding__brand-text" title={brandLabel}>{brandLabel}</span>
          </div>
          {onClose && (
            <button type="button" className="welcome-onboarding__close" onClick={onClose} aria-label={closeLabel}>
              x
            </button>
          )}
        </div>

        {progressMode === 'memberPortrait' && renderMemberPortraitProgress({
          progressMetaStart,
          progressMetaEnd,
          progressPercent,
        })}
        {progressMode === 'setup' && renderSetupProgress({
          setupSteps,
          setupCurrentStep,
        })}

        <div className={stageClasses}>
          <div className={panelClasses}>
            {children}
          </div>
        </div>

        {footer}
      </div>
    </div>
  );
};

export default OnboardingShell;
